import { motion } from "framer-motion";
import { useState } from "react";

interface LoadingButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  loadingText?: string;
}

export function LoadingButton({ 
  children, 
  onClick, 
  className = "", 
  loadingText = "Processing..." 
}: LoadingButtonProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    if (onClick) {
      setIsLoading(true);
      
      // Simulate some async process
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      
      onClick();
    }
  };

  return (
    <motion.button
      className={`relative px-6 py-3 bg-[#ff8c42] text-white rounded-md font-medium ${className}`}
      onClick={!isLoading ? handleClick : undefined}
      whileHover={!isLoading ? { scale: 1.05 } : {}}
      whileTap={!isLoading ? { scale: 0.95 } : {}}
      transition={{ type: "spring", stiffness: 400, damping: 10 }}
      disabled={isLoading}
    >
      {isLoading ? (
        <div className="flex items-center justify-center">
          <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          {loadingText}
        </div>
      ) : (
        children
      )}
    </motion.button>
  );
}